/* istanbul ignore file */
import FormSection from '../../ui/layout/form/FormSection/FormSection';

export enum FormSectionType {
  DEFAULT = 'default',
}

type FormSectionProps = {
  type: FormSectionType;
  children: any;
  props: any;
};

const FormSectionFactory = ({ type, props, children }: FormSectionProps) => {
  switch (type) {
    case FormSectionType.DEFAULT:
      return <FormSection {...props}>{children}</FormSection>;
    default:
      return <></>;
  }
};

export default FormSectionFactory;
